import { Map } from 'immutable';
import { actionTypes as scanAssetPageActionTypes } from '../../../actions/Mobile/ScanAssetPage/scanAssetPageActions.js';

let defaultState = {
  loading: false,
  error : null,
  // locations: null,
};

export default function(state = Map(defaultState), action) {

  switch (action.type) {
    case scanAssetPageActionTypes.SCANASSET_PAGE_SUBMIT_IN_PROGRESS:
      state = state.set('loading', true)
        .set('error', null);
      return state;
    case scanAssetPageActionTypes.SCANASSET_PAGE_SUBMIT_FINISHED:
      state = state.set('loading', false)
        .set('error', null);
      return state;
    case scanAssetPageActionTypes.SCANASSET_PAGE_SUBMIT_FAILED:
      state = state.set('loading', false)
        .set('error', action.payload);
      return state;
    case scanAssetPageActionTypes.SCANASSET_PAGE_CLEAR:
      return Map(defaultState);
    // case scanAssetPageActionTypes.SCANASSET_PAGE_DATA_FETCHED:
    //   return state.set('locations', action.payload);


    default:
      return state;
  }
}












